import { QueryClient } from "@tanstack/react-query";
import { shouldBlockQueryRetry } from "@/lib/auth";

/** Shared client for `QueryClientProvider` and auth teardown (e.g. logout). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount) => {
        if (shouldBlockQueryRetry()) {
          return false;
        }
        return failureCount < 1;
      },
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      retry: 0,
    },
  },
});
